import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Divider,
  Typography,
  Autocomplete,
  InputAdornment,
  Box,
} from "@mui/material";
import RestAPIService from "../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Loader from '../../Components/Loader'
import { DateTime } from "luxon";
import { toDate } from "date-fns";
import ToastMsg from "../../Components/ToastMsg/ToastMsg";
import { abha_address_suffix } from "../../Utility/Constants";

const AbhaConsentForm = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [searchType, setSearchType] = useState("abhaAddress");
  const [searchValue, setSearchValue] = useState("");
  // const [isSearchValid, setIsSearchValid] = useState(true);
  const [patientData, setPatientData] = useState(null);
  const [purpose, setPurpose] = useState("");
  const [doctor, setDoctor] = useState("");
  const [healthInfo, setHealthInfo] = useState({
    selectAll: false,
    dischargeSummary: false,
    diagnosticReport: false,
    wellnessRecord: false,
    healthDocumentRecord: false,
    opConsultation: false,
    prescription: false,
    immunizationRecord: false,
    invoice: false,
  });
  const [doctorList, setDocList] = useState([])
  const [selectedDocId, setDocId] = useState(null)
  const [startDate, setstartDate] = useState(new Date())
  const [startPickerOpen, setStartPickerOpen] = useState(false)
  const [toDate, setToDate] = useState(new Date())
  const [toPickerOpen, setToPickerOpen] = useState(false)
  const [expiryDate, setExpiryDate] = useState(tomorrow)
  const [expiryPickerOpen, setexpiryPickerOpen] = useState(false)
  const [errorStatus, setErrorStatus] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [succStatus, setSuccStatus] = useState(false)
  const [succMsg, setSuccMsg] = useState('')
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try{
      var API_URL = Serviceurls.FO_CONFIG_OPDOCTORNAME
      RestAPIService.getAll(API_URL).
      then((response) => {
        if (response?.data?.status === "success") {
          setDocList(response?.data?.data.filter((item) => (item?.specialization_active === true)))
        }
        else {
          // this.errorMessage(response.data.message)
        }
      }).catch((error) => {
        // this.errorMessage(error.message)
      })

    }catch(e){

    }
  }, [])

  const msgClose = () => {
      setErrorStatus(false)
      setErrorMsg('')
      setSuccMsg('')
      setSuccStatus(false)
  }

  const errorMessage = (message) => {
      setErrorStatus(true)
      setErrorMsg(message)
  }

  const successMessage = (message) => {
      setSuccMsg(message)
      setSuccStatus(true)
  }
  // Handle search input validation
  const handleSearchChange = (event) => {
    let value = event.target.value;
    value = value.replace(/@/g, '').replace(/\s/g, '');
    setSearchValue(value);
    // if (searchType === "abhaAddress") {
    //   setIsSearchValid(value.includes("@"));
    // } 
    // else {
    //   setIsSearchValid(/^\d{2}-\d{4}-\d{4}-\d{4}$/.test(value));
    // }
  };

  const fetchPatient = () => {
    try{
      var API_URL = Serviceurls.ABHA_PATIENT_FIND + "?abha_health_address=" + searchValue + abha_address_suffix
      RestAPIService.getAll(API_URL).
      then((response) => {
        setLoading(false);
        if (response?.data?.status === "success") {
          setPatientData(response.data?.data)
        }
        else {
          errorMessage("User not found");
        }
      }).catch((error) => {
        setLoading(false);
        errorMessage("User not found");
      })
    }catch(e){
      setLoading(false);
      errorMessage("User not found");
    }
  }

  // Handle search action
  const handleSearch = () => {
      try{
      setLoading(true);
      var url = Serviceurls.ABHA_PATIENT_FIND
      var Address = searchValue.trim() ? searchValue.trim() + abha_address_suffix : "";
      var data = {
        'abha_health_address': Address
      }
      RestAPIService.create(data, url)
      .then(response => {
        if(response.data?.status === "success"){
          const timer = setTimeout(() => {
            fetchPatient()
          }, 3000); // 3 seconds
      
          return () => clearTimeout(timer);
        }else{
          setLoading(false);
          errorMessage("Invalid ABHA Address");
        }
      })
      .catch(e => {
        setLoading(false);
        errorMessage("Invalid ABHA Address");
      })
      }catch(e){
        errorMessage("Invalid ABHA Address");
      }
  };

  // Handle clear action
  const handleClear = () => {
    setSearchValue("");
    // setIsSearchValid(false);
    setPatientData(null);
    setPurpose("");
    setDoctor("");
    setDocId(null);
    setstartDate(new Date());
    setToDate(new Date());
    setExpiryDate(tomorrow);
    setStartPickerOpen(false);
    setToPickerOpen(false);
    setexpiryPickerOpen(false);
    setLoading(false);
    setHealthInfo({
      selectAll: false,
      dischargeSummary: false,
      diagnosticReport: false,
      wellnessRecord: false,
      healthDocumentRecord: false,
      opConsultation: false,
      prescription: false,
      immunizationRecord: false,
      invoice: false,
    });
  };

  // Handle checkbox changes
  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (event.target.name === "selectAll") {
      setHealthInfo({
        selectAll: isChecked,
        dischargeSummary: isChecked,
        diagnosticReport: isChecked,
        wellnessRecord: isChecked,
        healthDocumentRecord: isChecked,
        opConsultation: isChecked,
        prescription: isChecked,
        immunizationRecord: isChecked,
        invoice: isChecked,
      });
      return;
    }else {
      setHealthInfo((prev) => {
        const updatedState = {
          ...prev,
          [event.target.name]: isChecked,
        };

        // Check if ALL individual checkboxes are true
        const { selectAll, ...otherChecks } = updatedState;
        const allSelected = Object.keys(otherChecks).every((key) => updatedState[key] === true);

        return {
          ...updatedState,
          selectAll: allSelected,
        };
      });
    }
  };

  const DatetimeFormat = (date) => {
    let startDate = new Date(date)
    let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
    let formatted_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""
    return formatted_date
  }

  const postConsent = () => {
    try{
      setLoading(true);
      var hi_types = []
      if(healthInfo?.dischargeSummary){
        hi_types.push('DischargeSummary')
      }
      if(healthInfo?.diagnosticReport){
        hi_types.push('DiagnosticReport')
      }
      if(healthInfo?.healthDocumentRecord){
        hi_types.push('HealthDocumentRecord')
      }
      if(healthInfo?.immunizationRecord){
        hi_types.push('ImmunizationRecord')
      }
      if(healthInfo?.opConsultation){
        hi_types.push('OPConsultation')
      }
      if(healthInfo?.prescription){
        hi_types.push('Prescription')
      }
      if(healthInfo?.wellnessRecord){
        hi_types.push('WellnessRecord')
      }
      if(healthInfo?.invoice){
        hi_types.push('Invoice')
      }
      var FromDate = DatetimeFormat(startDate) 
      var ToDate = DatetimeFormat(toDate)
      var ExpiryDate = DatetimeFormat(expiryDate)
      var url = Serviceurls.ABHA_CONSENT_INIT
      var data = {
        "doctor_id": selectedDocId?.doctor_id,
        'abha_health_address': patientData?.id,
        'purpose_of_request': purpose,
        'request_hi_types': hi_types,
        'permission_date_range_from': FromDate,
        'permission_date_range_to': ToDate,
        'permission_data_erased_at': ExpiryDate
      }

      RestAPIService.create(data, url)
      .then(response => {
        setLoading(false);
        if(response.data?.status === "success"){
          successMessage(response.data?.message);
          handleClear();
        }else{
          errorMessage("Failed to send consent request");
        }
      })
      .catch(e => {
        setLoading(false);
        errorMessage("Failed to send consent request");
      })
    }catch(e){
      errorMessage("Failed to send consent request");
    }
  }


  return (
    <div style={{ padding: 20, width: "100%", minHeight: "100%", boxSizing: "border-box" }}>
      {/* First Portion */}
      <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 20, width: "70%" }}>
        <FormControl style={{ minWidth: 150 }}>
          <Select size="small" value={searchType} onChange={(e) => setSearchType(e.target.value)}>
            <MenuItem value="abhaAddress">ABHA Address</MenuItem>
            {/* <MenuItem value="abhaNumber">ABHA Number</MenuItem> */}
          </Select>
        </FormControl>
        <TextField
          size="small"
          value={searchValue}
          onChange={handleSearchChange}
          placeholder={searchType === "abhaAddress" ? "Enter ABHA Address" : "Enter ABHA Number"}
          style={{ flexGrow: 1 }}
          // error={searchValue !== "" && !isSearchValid}
          // helperText={searchValue !== "" && !isSearchValid ? "Invalid format" : ""}
          InputProps={{
            endAdornment:(
              <InputAdornment position="end">
                <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ color: "#888", fontSize: "14px !important", mr: 1 }}>{abha_address_suffix}</Typography>
                </Box>
              </InputAdornment>
            )
          }}
        />
        <Button variant="contained" color="primary" sx={{textTransform:'capitalize'}} disabled={!searchValue} onClick={handleSearch}>
          Search
        </Button>
        <Button variant="outlined" onClick={handleClear} sx={{textTransform:'capitalize'}}>
          Clear
        </Button>
      </div>

      <Divider />

      {/* Second Portion: Patient Details */}
      {patientData && (
        <>
          <Typography variant="h6" style={{ margin: "20px 0 10px" }}>
            Patient Details
          </Typography>
          <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
            <TextField size="small" label="Patient Name" value={patientData?.name} fullWidth disabled />
            <TextField size="small" label="ABHA Address" value={patientData?.id} fullWidth disabled />
            {/* <TextField size="small" label="ABHA Number" value={patientData?.abhaNumber} fullWidth disabled /> */}
          </div>
          <Divider />
        </>
    )}

      {/* Third Portion: Consent Section */}
      <Typography style={{ margin: "20px 0 10px", fontSize: "1vw", fontWeight: 600 }}>
        Consent
      </Typography>

      {/* Purpose of Request & Doctor in Single Row */}
      <div style={{ display: "flex", gap: '10%', marginBottom: 20 }}>
        <FormControl fullWidth size='small'>
            <InputLabel id="purpose">{"Purpose of Request"}</InputLabel>
            <Select
                labelId="purpose"
                id="demo-simple-select"
                value={purpose}
                name={"Purpose of Request"}
                label={"Purpose of Request"}
                onChange={(e) => setPurpose(e.target.value)}
            >
                <MenuItem key={1} value="CAREMGT">Care Management</MenuItem>
                <MenuItem key={2} value="BTG">Break the Glass</MenuItem>
                <MenuItem key={3} value="PUBHLTH">Public Health</MenuItem>
                <MenuItem key={4} value="HPAYMT">Healthcare Payment</MenuItem>
                <MenuItem key={5} value="DSRCH">Disease Specific Healthcare Research</MenuItem>
                <MenuItem key={6} value="PATRQT">Self-Requested</MenuItem>
            </Select>
        </FormControl>
        <Autocomplete
          fullWidth
          size='small'
          // clearIcon={false}
          // sx={{ width: '10vw' }}
          options={doctorList}
          getOptionLabel={(item) => (item.doctor_name)}
          value={selectedDocId}
          onChange={(event, newValue) => {
            setDocId(newValue)
          }}
          onKeyDown={(e) => e.stopPropagation()}
          renderInput={(params) => (
            <TextField
              {...params}
              label={'Select Doctor'}
              placeholder={'Select Doctor'}
            // onKeyDown={(e) => { e.stopPropagation() }}
            />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option?.doctor_id}>
              {option?.doctor_name}
            </li>
          )}
        />
      </div>
      {/* Health Info Checkboxes */}
      <Typography variant="subtitle1">Health Info Type</Typography>
      <FormGroup row>
        {Object.keys(healthInfo).map((key) => (
          <FormControlLabel
            key={key}
            control={<Checkbox checked={healthInfo[key]} onChange={handleCheckboxChange} name={key} />}
            label={key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}
          />
        ))}
      </FormGroup>
      <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '1%' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label={"From Date  & Time"}
          open={startPickerOpen}
          onOpen={() => {setStartPickerOpen(true) }}
          onClose={() => { setStartPickerOpen(false) }}
          value={startDate}
          inputFormat='DD-MM-YYYY & hh:mm A'
          maxDateTime={new Date().setHours(new Date().getHours())}
          onChange={
            (newDate) => {
              setstartDate(newDate)
            }}
          renderInput={(params) => <TextField
            autoComplete="off"
            onKeyDown={(e) => {
              e.preventDefault()
              // e.stopPropagation()
            }} style={{ width: '25vw' }} size='small' {...params} onClick={() => { setStartPickerOpen(true) }} />}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label={"To Date & Time"}
          open={toPickerOpen}
          onOpen={() => {setToPickerOpen(true) }}
          onClose={() => { setToPickerOpen(false) }}
          value={toDate}
          inputFormat='DD-MM-YYYY & hh:mm A'
          maxDateTime={new Date().setHours(new Date().getHours())}
          onChange={
            (newDate) => {
              setToDate(newDate)
            }}
          renderInput={(params) => <TextField
            autoComplete="off"
            onKeyDown={(e) => {
              e.preventDefault()
              // e.stopPropagation()
            }} style={{ width: '25vw' }} size='small' {...params} onClick={() => { setToPickerOpen(true) }} />}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label={"Expiry Date & Time"}
          open={expiryPickerOpen}
          onOpen={() => {setexpiryPickerOpen(true) }}
          onClose={() => { setexpiryPickerOpen(false) }}
          minDate={new Date().setHours(new Date().getHours())}
          value={expiryDate}
          inputFormat='DD-MM-YYYY & hh:mm A'
          onChange={
            (newDate) => {
              setExpiryDate(newDate)
            }}
          renderInput={(params) => <TextField
            autoComplete="off"
            onKeyDown={(e) => {
              e.preventDefault()
              // e.stopPropagation()
            }} style={{ width: '25vw' }} size='small' {...params} onClick={() => { setexpiryPickerOpen(true) }} />}
        />
      </LocalizationProvider>
    </div>

      {/* Submit and Reset Buttons */}
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <Button 
        onClick={postConsent}
        variant="contained" 
        sx={{textTransform:'capitalize'}} 
        disabled={!patientData?.id || !purpose || !selectedDocId || !startDate || !toDate || !expiryDate || Object.values(healthInfo).every(v => !v)}
        color="primary">
          Submit
        </Button>
        <Button variant="outlined" onClick={handleClear} sx={{textTransform:'capitalize'}}>
          Reset
        </Button>
      </div>
      <Loader loaderOpen={loading} />
      {(errorStatus && errorMsg ) ?
      <ToastMsg
      severity={'error'}
      msg={errorMsg}
      msgPop={msgClose}
      />
      : null}
      {(succStatus && succMsg) ?
      <ToastMsg
      severity={'success'}
      msg={succMsg}
      msgPop={msgClose}
      />
      : null}
    </div>
  );
};

export default AbhaConsentForm;
